var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-ppt"},[_c('div',{staticClass:"m-ppt-title",style:({'text-align':_vm.textAlign})},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }